import styled from 'styled-components';

export const NoResultScreenSection = styled.div`
  margin: 30px 0;
  text-align: center;
`;

export const NoResultLine = styled.p`
  font-size: clamp(16px, 2vw, 20px);
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 78%);
`;

export const SadImage = styled.img`
  width: 100px;
  height: auto;
  margin: 16px 0;
`;

export const TrySearch = styled.p`
  font-size: clamp(14px, 2vw, 16px);
  color: hsl(0deg, 0%, 0%, 78%);
`;

export const RetryBtn = styled.button`
  font-family: 'Montserrat';
  background: #fff;
  color: #ef4e5e;
  font-size: 16px;
  font-weight: 600;
  border: none;
  outline: none;
  margin: 16px 0;
  @media (min-width: 720px) {
    cursor: pointer;
  }
`;
